window.addEventListener('load', () => {

  var $body = document.body,
    vh = window.innerHeight * 0.01;

  // body にカスタム変数（--vh）を設定
  $body.style.setProperty('--vh', `${vh}px`);

});